import { RefObject, useEffect } from 'react'
import { useSpiffClient } from '../../hooks/useSpiffClient'
import { TitleBar } from '../TitleBar/TitleBar'
import { OnBodyPreview } from './OnBodyPreview'
import { Loader } from '../Loader/Loader'

const Canvas = ({ canvasRef, spiffState }: { canvasRef: RefObject<HTMLCanvasElement>; spiffState: ReturnType<typeof useSpiffClient> }) => {
  const { bundle, isLoading, setIsLoading } = spiffState
  const baseProductName = bundle?.getWorkflowExperiences()[0]?.getWorkflowManager().getProduct().name

  const preventScroll = (e: WheelEvent | TouchEvent) => {
    if (e.target === canvasRef.current) {
      e.preventDefault()
    }
  }

  useEffect(() => {
    window.addEventListener('wheel', preventScroll, { passive: false })
    window.addEventListener('touchmove', preventScroll, { passive: false })

    return () => {
      window.removeEventListener('wheel', preventScroll)
      window.removeEventListener('touchmove', preventScroll)
    }
  }, [])

  return (
    <div className="sticky z-[2] top-[40px] lg:top-[54px] w-full">
      <div className="sticky top-[40px] lg:top-[54px]">
        {bundle && baseProductName && <TitleBar bundle={bundle} baseProductName={baseProductName} isLoading={isLoading} className="flex md:hidden" />}
        <div className="relative">
          {bundle && <OnBodyPreview bundle={bundle} setIsLoading={setIsLoading} />}
          <canvas ref={canvasRef} className="w-full h-auto aspect-square md:h-[calc(100vh_-_54px)] md:aspect-[auto] lg:aspect-[947/752] bg-[#e8e8e8]" width="962" height="763" />
          {isLoading && <Loader />}
        </div>
      </div>
    </div>
  )
}

export default Canvas
